import { Margin } from 'recharts/types/util/types';

// Chart styling constants
export const DEFAULT_STROKE_WIDTH = 2;
export const DEFAULT_LEGEND_HEIGHT_OFFSET = 20;
export const DEFAULT_DOT_RADIUS = 3;

// Grid and axis styling constants
export const GRID_OPACITY = 0.12;
export const CURSOR_OPACITY = 0.3;
export const CURSOR_STROKE_WIDTH = 1;

// Tick styling constants
export const TICK_FONT_SIZE = '10px';
export const TICK_MARGIN = 8;
export const Y_AXIS_WIDTH = 24;

// Chart margins
export const CHART_MARGIN: Margin = {
  top: 8,
  right: 16,
  left: 16,
  bottom: 8,
};

// Typography spacing
export const NO_DATA_TYPOGRAPHY_MARGIN = 2;
